<script setup>
const props = defineProps({
  anime: {
    type: Object,
    default: () => {}
  }
})

const formatDate = (dateStr) => {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  const day = String(d.getUTCDate()).padStart(2, '0')
  const month = String(d.getUTCMonth() + 1).padStart(2, '0')
  const year = d.getUTCFullYear()
  return `${day}.${month}.${year}`
}

const getSecondTitle = (data) => {
  return `${data.title.split('/')[1]}, ${formatDate(data.date)}, `
}
</script>

<template>
  <div
    class="flex flex-col gap-[5px] bg-neutral/80 shadow-lg mt-[20px] px-[12px] py-[16px] rounded-[12px] w-full text-sm"
  >
    <div class="text-neutral-content">
      <span class="opacity-60">{{ $t('status') }}: </span>
      <span class="font-bold">{{
        anime?.watched ? $t('watched') : $t('watching')
      }}</span>
    </div>
    <div class="text-neutral-content">
      <span class="opacity-60">{{ $t('epwached') }}: </span>
      <span class="font-bold">{{
        `${
          anime?.maxepisodes == 1
            ? $t('film')
            : anime?.nowepisode +
              ' ' +
              $t('iz') +
              ' ' +
              anime?.maxepisodes +
              ' ' +
              $t('ep')
        }`
      }}</span>
    </div>
    <div class="text-neutral-content">
      <span class="opacity-60">{{ $t('watcheddate') }}: </span>
      <span class="font-bold">{{ formatDate(anime?.date) }}</span>
    </div>
    <div class="text-neutral-content">
      <span class="opacity-60">{{ $t('genres') }}: </span>
      <span class="font-bold"
        >{{ anime?.genres.toString().split(',').join(', ') }}
      </span>
    </div>
  </div>
</template>
